import React, { useState } from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const StarRanker = ({
  value,      
  onChange,
  style,
  className,
  minValue = 1,
  maxValue = 5,
  detailMenuOnOneStar = false,
  dataTip
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  
  const starRange = Array.from({ length: maxValue - minValue + 1 }, (_, i) => i + minValue);
  return (
    <Tooltip title={dataTip || ''} placement="top">
      <Wrapper
        style={style}
        className={className}
      >
        {starRange.map((i) => {
          const filledIn = value >= i;
          if(filledIn) {
            return <StarIcon key={i} onClick={i === 1 && detailMenuOnOneStar ? openMenu : () => onChange(i)} />
          } else {
            return <StarBorderIcon key={i} onClick={i === 1 && detailMenuOnOneStar ? openMenu : () => onChange(i)} />
          }
        })}
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Typography variant='body1' style={{ margin: '4px 12px', fontWeight: 'bold'}}>Why is this stance being hidden?</Typography>
        <MenuItem onClick={() => {
          onChange(1, 'useless')
          setAnchorEl(null)
        }}>
          <Typography variant='body1' style={{ margin: '2px 6px'}}>
            Nonsense or irrelvant information
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          onChange(1, 'redundant')
          setAnchorEl(null)
        }}>
          <Typography variant='body1' style={{ margin: '2px 6px'}}>
            Redundant with other stances
          </Typography>
        </MenuItem>
      </Menu>
    </Wrapper>
    </Tooltip>
  )
}

const Wrapper = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  cursor: pointer;

`

export { StarRanker };